import React from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import authConfig from './authConfig';

const SSO_WINDOW_NAME = 'sso_login_window';

// react-oidc-context passes the signed-in User object as the first argument
function onSigninCallback(user) {
  // onSigninCallback executed (debug logs removed for privacy)

  const returnTo = sessionStorage.getItem('returnTo') || '/';
  sessionStorage.removeItem('returnTo');

  const isSsoWindow = window.name === SSO_WINDOW_NAME;
  // isSsoWindow check performed (log removed)

  if (isSsoWindow) {
    // SSO window flow: send signals and close (logs removed)

    // PRIMARY SIGNAL — postMessage user object directly to opener (the iframe).
    // This is the ONLY reliable cross-partition channel:
    //   - Chrome partitions localStorage for third-party iframes (different storage bucket)
    //   - storage event, BroadcastChannel, and localStorage polling all fail across partitions
    //   - postMessage uses direct window references — unaffected by storage partitioning ✅
    try {
        if (window.opener && !window.opener.closed) {
          const userJson = JSON.parse(JSON.stringify(user));
          window.opener.postMessage({ type: 'sso_user_data', user: userJson }, window.location.origin);
        } else {
          // No opener available — using legacy fallback signals
        }
    } catch (e) {
      console.error(':mag: [onSigninCallback] postMessage failed');
    }

    // FALLBACK SIGNALS — work when NOT in a partitioned iframe context
    try {
      localStorage.setItem('sso_complete', 'true');
    } catch (e) {
      // localStorage fallback failed (silently ignored)
    }
    try {
      const channel = new BroadcastChannel('sso_channel');
      channel.postMessage('sso_complete');
      setTimeout(() => channel.close(), 2000);
    } catch (e) {
      // BroadcastChannel fallback failed (silently ignored)
    }

    // Close login window
    setTimeout(() => {
      window.close();
    }, 800);
    return;
  }

  // Normal full tab — restore original page
  // Normal tab — restoring original page (log removed)
  window.history.replaceState({}, document.title, returnTo);
}

export default function AuthProvider({ children }) {
  return (
    <OidcAuthProvider {...authConfig} onSigninCallback={onSigninCallback}>
      {children}
    </OidcAuthProvider>
  );
}